import React, { Component } from "react";
import { connect } from "react-redux";
import { updateUser } from "../../../actions/user.js";

// import Row from '../../../common/grid/Row'
import Col from "../../../common/grid/Col";
import Button from "../../../common/button/Button";
import Section from "../../../common/section/Section";
import UploadButton from "../../../common/button/UploadButton";
import PlaceholderThumb from "../../../common/thumb/PlaceholderThumb";

class ProfileImage extends Component {
  state = {
    file: "",
    imagePreviewUrl: "",
    confirmation: false,
    range: 100
  };

  componentWillUpdate(nextProps, nextState) {
    const { confirmation } = this.state;
    if (nextState.confirmation !== confirmation) {
      document.body.classList.toggle("focused-out", nextState.confirmation);
    }
  }

  handleChange = e => {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        file: file, // TODO: upload or do something with this
        imagePreviewUrl: reader.result,
        confirmation: true
      });
    };

    reader.readAsDataURL(file);
  };

  handleRangeChange = e => {
    this.setState({
      range: e.target.value
    });
  };

  applay = () => {
    // Upload new photo
    console.log(this.state.file);
    console.log(this.props.userId);
    this.props.updateUser(this.props.userId, {
      profile_photo: this.state.file
    });
    this.setState({
      confirmation: false
    });
  };

  cancel = () => {
    this.setState({
      confirmation: false,
      imagePreviewUrl: "",
      range: 100
    });
  };

  render() {
    const { imagePreviewUrl, confirmation, range } = this.state;
    const { profile_photo_url } = this.props;
    const { first_name, last_name, color } = this.props.user;
    const imageStyles = {
      width: range + "%"
    };

    return (
      <Section
        heading={"Profile"}
        className="profile-image white"
        style={confirmation ? { zIndex: 99999 } : { zIndex: 0 }}
      >
        <Col _bottom-16 _no-grow>
          <div className="thumbnail">
            {imagePreviewUrl || profile_photo_url ? (
              <img
                src={imagePreviewUrl || profile_photo_url}
                alt=""
                style={imageStyles}
              />
            ) : (
              <PlaceholderThumb
                firstName={first_name}
                lastName={last_name}
                size={96}
                contactDefaultPhoto={color}
              />
            )}
          </div>
          {confirmation && (
            <Col _bottom-16 _no-grow>
              <span>Tip: try zooming in until the gray space disappears</span>
              <input
                type="range"
                min={100}
                max={200}
                value={range}
                onChange={this.handleRangeChange}
              />
              <Button className="btn-green btn-square" onClick={this.applay}>
                Applay Changes
              </Button>
              <Button className="btn-red btn-square" onClick={this.cancel}>
                Cancel
              </Button>
            </Col>
          )}
          {!confirmation && (
            <UploadButton
              className="btn-blue btn-square"
              onChange={this.handleChange}
            >
              Change Thumbnail
            </UploadButton>
          )}
        </Col>
      </Section>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.currentUser.id,
    profile_photo_url: state.auth.currentUser.profile_photo_url,
    user: state.auth.currentUser
  };
};

export default connect(mapStateToProps, { updateUser })(ProfileImage);



// WEBPACK FOOTER //
// ./src/components/main/profile/ProfileImage.js